// extracted by mini-css-extract-plugin
module.exports = {"qr-modal-portal":"jgp-2Lnis"};